import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Container, Alert, Spinner } from 'react-bootstrap';

const OAuth2RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setCurrentUser } = useAuth();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const token = urlParams.get('token');
    const error = urlParams.get('error');

    if (token) {
      // Parse JWT token to get user info
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        
        // Create user object similar to regular login
        const userData = {
          accessToken: token,
          tokenType: 'Bearer',
          username: payload.sub,
          email: payload.email || payload.sub,
          roles: ['ROLE_USER'], // Default role for OAuth2 users
          authProvider: 'google'
        };

        // Store in localStorage
        localStorage.setItem('user', JSON.stringify(userData));
        
        // Update auth context
        setCurrentUser(userData);

        // Redirect to dashboard
        navigate('/dashboard', { replace: true });
      } catch (err) {
        console.error('Error parsing OAuth2 token:', err);
        navigate('/login?error=oauth2_token_error', { replace: true });
      }
    } else if (error) {
      console.error('OAuth2 authentication error:', error);
      navigate('/login?error=' + encodeURIComponent(error), { replace: true });
    } else {
      navigate('/login?error=oauth2_no_token', { replace: true });
    }
  }, [location, navigate, setCurrentUser]);

  return (
    <Container className="mt-5 text-center">
      <Spinner animation="border" role="status" className="mb-3">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      <h4>Processing OAuth2 login...</h4>
      <p>Please wait while we complete your authentication.</p>
    </Container>
  );
};

export default OAuth2RedirectHandler;